import { FormInput } from "./form-components/form-input.components";
import { useFieldArray, type UseFormReturn } from "react-hook-form";
import { FormLabel } from "./ui/form";
import { Button } from "./ui/button";
import DeleteIcon from "../assets/svgs/common/delete.svg";
import StarIcon from "../assets/svgs/common/star.svg";
import type { IzCampaignFormAdmin } from "../z/admin/campaign-form.admin.z";
import AddIcon from "../assets/svgs/common/add.svg";
import { Switch } from "./ui/switch";

type MileStoneProps = {
	form: UseFormReturn<IzCampaignFormAdmin>; // Use the specific form type
	label1: string;
	label2: string;
	required?: boolean;
};

const MileStoneComponent = ({
	form,
	label1,
	label2,
	required,
}: MileStoneProps) => {
	const { fields, append, remove } = useFieldArray({
		control: form.control,
		name: "milestones",
	});

	function handleCheckChange() {
		if (fields.length) {
			return fields.map((_, index) =>
				remove(fields.findIndex((item) => item.id === index.toString())),
			);
		}
		append({
			count: "" as unknown as number,
			payout: "" as unknown as number,
		});
	}

	return (
		<div
			className={`flex flex-col px-8 py-7 border border-border rounded-xl w-full ${fields.length ? "gap-10 " : ""}`}
		>
			<div className="flex justify-between items-center w-full font-semibold">
				<p>Milestone</p>
				<Switch
					id="is-active"
					checked={fields.length > 0}
					className={fields.length ? "bg-primarybuttonbg" : ""}
					onCheckedChange={handleCheckChange}
				/>
			</div>
			<div className="flex flex-col gap-2 w-full">
				{fields.length > 0 && (
					<div className="flex items-center gap-4 w-full">
						<FormLabel className="flex flex-1 items-center gap-1 font-semibold">
							{label1} {required && <StarIcon />}
						</FormLabel>
						<FormLabel className="flex flex-1 items-center gap-1 mr-20 font-semibold">
							{label2} {required && <StarIcon />}
						</FormLabel>
					</div>
				)}

				<div className="flex flex-col gap-4 w-full">
					{fields.map((item, index) => (
						<div
							key={item.id}
							className="relative flex items-center gap-4 w-full"
						>
							<FormInput
								form={form}
								name={`milestones.${index}.count`}
								placeholder="Enter count"
								required={false}
								type="number"
							/>

							<FormInput
								form={form}
								name={`milestones.${index}.payout`}
								placeholder="Enter payout"
								required={false}
								type="number"
							/>
							<Button
								type="button"
								onClick={() => remove(index)}
								className="bg-transparent py-4 border border-border rounded-xl w-fit h-full"
							>
								<DeleteIcon />
							</Button>
						</div>
					))}
					<div className="flex justify-end items-center w-full">
						<div
							className={` items-center gap-1 ${fields.length ? "flex" : "hidden"}`}
						>
							<Button
								type="button"
								onClick={() =>
									append({
										count: "" as unknown as number,
										payout: "" as unknown as number,
									})
								}
								className="flex items-center gap-1 bg-tertiarybuttonbg px-7 py-7 border border-border font-semibold self-end"
							>
								<AddIcon />
								{fields.length === 0
									? "Add milestone"
									: "Add another milestone"}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MileStoneComponent;
